import { createSlice /* PayloadAction */ } from '@reduxjs/toolkit';

const name = 'wallet';

// export interface WalletState {
//     kind: string; // 지갑종류
//     connected: boolean; // 지갑 연결 여부
//     address:string; // 지갑 주소
//     balance:string; // 지갑 잔액
// }

// const initialState: WalletState = {
//   kind: '',
//   connected: false,
//   address: '',
//   balance: '0.0',
// };

const initialState = {
  kind: '',
  connected: false,
  address: '',
  balance: '0.0',
  chainId: undefined,
  balanceForGear: '0',
};

// export const walletSlice = createSlice({
//   name: name,
//   initialState,
//   reducers: {
//     setConnected: (state, action: PayloadAction<boolean>) => {
//       state.connected = action.payload;
//     },
//     setKind: (state, action: PayloadAction<string>) => {
//       state.kind = action.payload;
//     },
//     setBalance: (state, action: PayloadAction<string>) => {
//       state.balance = action.payload;
//     },
//     setAddress: (state, action: PayloadAction<string>) => {
//       state.address = action.payload;
//     },
//   },
// });

export const walletSlice = createSlice({
  name: name,
  initialState,
  reducers: {
    setConnected: (state, action) => {
      state.connected = action.payload;
    },
    setKind: (state, action) => {
      state.kind = action.payload;
    },
    setBalance: (state, action) => {
      state.balance = action.payload;
    },
    setAddress: (state, action) => {
      state.address = action.payload;
    },
    setChainId: (state, action) => {
      state.chainId = action.payload;
    },
    setBalanceForGear: (state, action) => {
      state.balanceForGear = action.payload ?? '0';
    },
  },
});

export const {
  setConnected,
  setKind,
  setBalance,
  setAddress,
  setChainId,
  setBalanceForGear,
} = walletSlice.actions;

export default walletSlice.reducer;
